<script>
	import Homepage from './pages/homepage/homepage.svelte'
	import Login from './pages/login/login.svelte'
	import Results from './pages/Result/result.svelte'
	import { Router, Route } from "svelte-routing"
	import {setupAxios} from "./app/request"
	setupAxios()
</script>

<style>
	:global(*) {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		color: white;
	}
	:global(html, body) {
		background-color: #242927;
	}
	#container {
		max-width: 768px;
		margin: 0 auto;
	}
</style>

<div id="container">
    <Router>
        <Route path="results" component={Results} />
        <Route path="login" component="{Login}" />
        <Route path="/" component={Homepage} />
    </Router>
</div>

